import React from "react";
import Nav from "../components/sections/Nav";
import Footer from "../components/sections/Footer";
import ContactSection from "../components/sections/ContactSection";
import SectionDivider from "../components/SectionDivider";
import RevealOnScroll from "../components/RevealOnScroll";
import Seo from "../components/Seo";

const Hero = () => (
    <section
        data-testid="contact-page-hero"
        className="relative pt-44 pb-28 lg:pt-52 lg:pb-32"
        style={{ background: "#EEF2ED" }}
    >
        <div className="mx-auto max-w-[900px] px-6 lg:px-12 text-center" data-reveal>
            <span className="editorial-eyebrow">Get in Touch</span>
            <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-[68px] leading-[1.05] text-charcoal text-balance">
                Let's find the right <em className="italic text-gold">next step</em> — together.
            </h1>
            <div className="mx-auto mt-8" style={{ height: 2, width: 64, background: "#8A9E85" }} />
        </div>
    </section>
);

export default function ContactPage() {
    return (
        <main className="bg-ivory text-charcoal" data-testid="contact-page">
            <Seo
                title="Contact | Alchemy Practice"
                description="Two ways to connect with Alchemy Practice — schedule a free consultation or send a quiet note. Virtual therapy in Wisconsin and Colorado."
            />
            <Nav />
            <RevealOnScroll>
                <Hero />
                <SectionDivider color="gold" bg="#EEF2ED" />
                <ContactSection />
                <Footer />
            </RevealOnScroll>
        </main>
    );
}
